import { translate } from '../../../common/utility/DisplayPrep';
const { READ_ONLY_FEATURES } = process.env;

const actions = READ_ONLY_FEATURES === 'true' ? ['edit'] : ['edit', 'delete'];

const defaultUiConfig = {
    name: 'Concept Determination Methods',
    withActions: [...actions],
    primaryKey: 'codeId',
    pageSize: 10,
    properties: {
        codeId: {
            name: 'ID',
            sortable: true,
            input: (v) => {
                return typeof v.codeId !== 'undefined' ? 'valueDisplay' : null;
            }
        },
        code: {
            name: 'Code',
            sortable: true,
            rowDisplay: true,
            nullable: false,
            input: 'text'
        },
        displayName: {
            name: 'Name',
            sortable: true,
            rowDisplay: true,
            max: 512,
            min: 0,
            input: 'text'
        },
        uuid: {
            rowDisplay: false,
            sortable: true,
            name: 'Uuid'
        },
        lastModId: {
            rowDisplay: false,
            sortable: true,
            name: 'Last Modified ID'
        },
        lastModDatetime: {
            rowDisplay: false,
            displayPrep: 'FullDate',
            name: 'Last Modified Datetime',
            additionalProperties: {
                Cell: ({ cell: { value } }) => {
                    return translate.ReadableDateTimeColumn(value);
                }
            }
        },
        createId: {
            rowDisplay: false,
            name: 'Create ID'
        },
        createDatetime: {
            rowDisplay: false,
            name: 'Create Datetime'
        }
    },
    newDoc: {
        code: null,
        codeId: null,
        createDatetime: null,
        createId: null,
        displayName: null,
        dtoState: 'NEW',
        lastModDatetime: null,
        lastModId: null,
        uuid: null
    }
};

export default defaultUiConfig;
